export const FIELD_TYPES = {
  TAGS: 'tags',
  TEXT: 'text',
  NUMBER: 'number',
  DROPDOWN: 'dropdown',
  DATE: 'date',
  BUTTON_GROUP: 'button-group',
  SELECT: 'select',
  CURRENCY: 'currency',
  TEXTAREA: 'textarea',
  CHIPS: 'chips',
  SEGMENTED_CONTROL: 'segmented-control',
  RADIO_GROUP: 'radio-group'
};

export const FIELDS_WITH_LABEL = [
  FIELD_TYPES.TEXT,
  FIELD_TYPES.NUMBER,
  FIELD_TYPES.CURRENCY,
  FIELD_TYPES.SELECT,
  FIELD_TYPES.TEXTAREA,
  FIELD_TYPES.DROPDOWN,
  FIELD_TYPES.SEGMENTED_CONTROL
];

/**
 * Check if a given field type is a custom field type
 * @param {String} filedType
 * @return {*}
 */
export const isCustomType = (filedType = '') => !FIELD_TYPES[filedType];

/**
 * Remove item from array
 * @param {Array} array
 * @param {String} item
 * @return {*}
 */
export const removeItemFromArray = (array, item) => {
  const index = array.indexOf(item);
  if (index > -1) {
    array.splice(index, 1);
  }
  return array;
};


/**
 * Given a single item option, it will return the display content and the actual value
 * @param {HTMLElement} item
 * @return {{value: *, content: *}}
 */
export const getItemContentAndValue = item => {
  let itemValue; let itemContent;
  if (item.value) {
    // In case we use <option value="someValue">someInnerContent</option>
    itemValue = item.value;
    itemContent = item.children.length ? item.innerHTML : item.innerText;
  } else {
    itemValue = itemContent = item;
  }
  return { itemValue, itemContent };
};
